export const DATE_FORMAT = 'dd/MM/yyyy';
export const DATE_TIME_FORMAT = 'dd/MM/yyyy HH:mm';
export const DEFAULT_PAGE_SIZE = 10;
export const TOAST_DURATION = 3000; //in milliseconds
export const PAGE_SIZE_OPTIONS = [25, 50, 100];